<router-outlet *ngIf="env?.user"></router-outlet>
